export default {
  nav: {
    home: "Home",
    about: "About",
    services: "Menu & Services",
    contact: "Contact",
  },
  language: {
    vietnamese: "Vietnamese",
    english: "English",
  },
  common: {
    readMore: "Read More",
    bookNow: "Book Now",
    viewDetails: "View Details",
    contactUs: "Contact Us",
    comingSoon: "Coming Soon",
    loading: "Loading...",
  },
  // Add translations for About section
  about: {
    title: "ABOUT NGOI SPA",
    description:
      "Are you looking for a place to unwind, nurture your body, and refresh your soul? Let Ngói Spa be your peaceful retreat from the hustle and bustle of daily life.",
    services:
      "Nestled in Tan Binh District, Ngói Spa is your ideal destination to relax and recharge with a full range of wellness services, including soothing spa treatments, rejuvenating facials, and elegant nail art. Every service is carried out by our dedicated team of skilled professionals who truly listen to your needs.",
    spa: "We combine gentle spa therapies with high-quality, safe, and skin-friendly products. Whether you’re looking to deeply hydrate, calm sensitive skin, or simply melt into a relaxing massage, Ngói Spa has a tailored experience just for you — all within a serene and healing atmosphere.",
    nail: "Don’t forget to pamper your hands and feet with our nail services. From timeless, minimalist styles to expressive and artistic designs, we bring out the beauty and personality in every set of nails.",
    contact:
      "Open daily from 9:30 AM to 8:00 PM, Ngói Spa welcomes you with warmth, care, and a sense of calm. Ngói Spa – Your peaceful space in the heart of the city. 🌿",
    features: {
      professional: {
        title: "Professional Technicians",
        description:
          "Dedicated, professional technicians team with licenses according to Ho Chi Minh City health department regulations.",
      },
      relaxing: {
        title: "Relaxing Space",
        description:
          "Clean, private, and safe beauty care space for women using beauty services.",
      },
      diverse: {
        title: "Diverse Services",
        description:
          "Ngoi Spa will help female customers experience various beauty care services.",
      },
      attentive: {
        title: "Attentive Service",
        description:
          "Consulting team with in-depth beauty knowledge, providing attentive service.",
      },
    },
  },
  // Add translations for Services section
  services: {
    title: "OUR SERVICES",
    description: "Discover our range of premium beauty and relaxation services",
    note: "This is a reference menu from Ngói. We regularly make small updates each month to refresh our services and offer special discounts from 10–30%.",
    viewAll: "View All Services",
    massage: {
      title: "RELAXING MASSAGE",
      price: "Starting from 180,000 VND",
      description:
        "Complete relaxation with professional massage therapies, using natural essential oils and traditional massage techniques to reduce stress, improve blood circulation and bring a sense of tranquility.",
    },
    facial: {
      title: "FACIAL - FACE CARE",
      price: "Starting from 180,000 VND",
      description:
        "Deep facial care services with modern technology and premium products. From basic cleansing to intensive treatment, we bring healthy and naturally radiant skin.",
    },
    hairWash: {
      title: "HERBAL HAIR WASH",
      price: "Starting from 180,000 VND",
      description:
        "Relaxing hair wash therapy with natural herbs, combined with professional scalp massage. Helps relax the mind, stimulate blood circulation and nourish hair from root to tip.",
    },
    nails: {
      title: "NAIL ART & MANICURE",
      price: "Starting from 180,000 VND",
      description:
        "Professional nail services with highly skilled technicians. From basic care to creative nail art, we bring you perfect nails according to your personal style.",
    },
    eyelashes: {
      title: "EYELASHES & EYELASH EXTENSIONS",
      price: "Starting from 180,000 VND",
      description:
        "Professional eyelash extension services with premium, safe materials. From natural lashes to dramatic lashes, creating charming and captivating eyes according to your desired style.",
    },
    waxing: {
      title: "WAXING - HAIR REMOVAL",
      price: "Starting from 180,000 VND",
      description:
        "Professional hair removal services with premium wax, safe for all skin types. Strict hygiene procedures, providing smooth skin and long-lasting results.",
    },
    bodyScrub: {
      title: "BODY SCRUB - EXFOLIATION",
      price: "Starting from 180,000 VND",
      description:
        "Full body exfoliation therapy with natural ingredients, helping skin become smooth and healthy. Combined with moisturizing masks to bring soft skin.",
    },
  },
  servicesSection: {
    title: "Our Services",
    description:
      "Ngoi Spa always puts customer satisfaction first with our experienced staff, high-quality products, and absolutely relaxing space. We are committed to bringing you the best service experiences.",
    videosTitle: "Discover Our Services Through Videos",
    viewAllServices: "View All Services",
  },
  // Add translations for Gallery section
  gallery: {
    title: "OUR SPACE",
    description: "Admire our beautiful and relaxing spa space",
    images: {
      image1: {
        title: "Nature in the spa",
        description: "Green plants create a natural relaxing space",
      },
      image2: {
        title: "Lobby area",
        description: "Fresh space that brings a sense of relaxation and peace",
      },
      image3: {
        title: "Relaxing massage room",
        description: "Clean, quiet and private",
      },
      image4: {
        title: "Convenient bathroom",
        description: "Modern and luxurious design",
      },
      image5: {
        title: "Fragrant flowers",
        description: "Small details that make the difference",
      },
      image6: {
        title: "Natural essential oils",
        description: "Premium care products",
      },
      image7: {
        title: "Main lobby",
        description: "Where the relaxation journey begins",
      },
    },
  },
  // Add translations for Video section
  video: {
    title: "EXPERIENCE NGOI SPA",
    description: "Watch our video to see the Ngoi Spa experience",
  },
  // Add translations for Contact section
  contact: {
    title: "GET IN TOUCH",
    findUs: "FIND US ON THE MAP",
  },
  // Add translations for Review section
  reviews: {
    subtitle: "What Clients Say",
    title: "Genuine Testimonials",
    description:
      "Client feedback is our greatest motivation to continuously improve and enhance service quality",
    items: {
      review1: {
        text: "Mình là khách hàng thân thuộc ở đây. Đến một lần là phải quay lại hoài vì tay nghề kĩ thuật viên và chị founder cực kì dễ thương và dồi dào kinh nghiệm. Hãy tin tôi. Ghé thử một lần, phải ghé suốt đời!",
        name: "Công Thoại",
        title: "Việt Nam",
      },
      review2: {
        text:
          "They are so friendly and helpful ❤️\n" +
          "If I had the chance I would give ten stars ✨✨✨✨\n" +
          "Also so clear and comfy place 🤗\n" +
          "I will come here again here s the best place for skin, hair, nail, massage and for more",
        name: "Ceyda",
        title: "Taiwan",
      },
      review3: {
        text: "I have visited 80+ countries and I can tell that the massage here is amazing. Whenever coming to Vietnam, I always take a taxi from my hotel in District 1 to get a 90-minute massage here.",
        name: "Mitt",
        title: "America",
      },
    },
  },
  // Add translations for Footer section
  footer: {
    tagline: "Beauty & Wellness",
    description:
      "Premium soul relaxation space where you find the perfect balance between natural beauty and healthcare artistry.",
    address: "Address",
    contact: "Contact",
    phone: "Phone",
    email: "Email",
    openingHours: "Opening Hours",
    everyday: "Monday - Sunday",
    appointmentNote: "Book in advance for the best service",
    privacyLink: "Privacy Policy",
    services: "Main Services",
    servicesItems: {
      massage: "Body Massage",
      facial: "Facial Care",
      nail: "Nail Art & Eyelashes",
      herbal: "Herbal Therapy",
      waxing: "Waxing",
      bodyScrub: "Body Scrub",
    },
    followUs: "Follow Us",
    copyright: "© 2026 Ngoi Spa. All rights reserved.",
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated",
    sections: {
      collect: {
        title: "Information Collection",
        desc: "We collect information to provide better services to you, including:",
        item1: "Personal info: Name, phone number when booking.",
        item2: "Service history: Treatment packages you have used.",
        item3: "Feedback: Customer reviews and suggestions.",
      },
      usage: {
        title: "Information Usage",
        desc: "Your information is used for the following purposes:",
        item1: "Confirming and reminding you of appointments.",
        item2: "Sending notifications about promotions and offers.",
        item3: "Improving customer service quality.",
      },
      security: {
        title: "Data Security",
        desc: "Ngói Spa is committed to absolute confidentiality of customer information. We do not share, sell, or rent your personal information to any third party for commercial purposes.",
      },
      contact: {
        title: "Contact Us",
        desc: "If you have any questions about this policy, please contact us via our official hotline or email.",
      },
    },
  },
};
